// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__109XS","file":"styles_file__1lzty"};